import type { CSSProperties } from "react";

// The three families the specimens show. Modam ships as a variable font without a weight range, so its weight goes through the wght axis.
export type FaceName = "peyda" | "modam" | "yekan";
export type Face = [FaceName, number];

const FAMILY: Record<FaceName, string> = { peyda: "Peyda", modam: "ModamVF, Modam", yekan: "IRANYekanXVF, IRANYekanX" };

export const faceStyle = ([name, weight]: Face): CSSProperties => ({
  fontFamily: FAMILY[name],
  fontWeight: weight,
  fontVariationSettings: `"wght" ${weight}`,
});
